import {
  compose,
  withPropsOnChange,
  withState,
} from 'recompose'
import { change } from 'redux-form'
import { connect } from 'react-redux'
import get from 'lodash/get'
import head from 'lodash/head'
import { omitProps } from '@infotech/base-components'
import { convertToExtraEquipment } from '@infotech/equipment-widget'

const equipmentWidgetAdapterOmittedProps = [
  `equipmentWidgetValue`, `changeEquipmentWidgetValue`, `meta`, `changeFormValue`,
]

const equipmentWidgetAdapter = compose(
  connect(
    null,
    (dispatch, { meta: { form } }) => ({
      changeFormValue: (field, value) => dispatch(change(form, field, value)),
    }),
  ),
  withState(`equipmentWidgetValue`, `changeEquipmentWidgetValue`, []),
  withPropsOnChange([`input`], ({
    input: { value },
    changeEquipmentWidgetValue,
  }) => {
    const extraEquipment = value
      ? [convertToExtraEquipment({ code: value })]
      : []
    changeEquipmentWidgetValue(extraEquipment)
  }),
  withPropsOnChange([`equipmentWidgetValue`], ({
    input: { onChange },
    equipmentWidgetValue,
    changeEquipmentWidgetValue,
    changeFormValue,
  }) => ({
    input: {
      value   : equipmentWidgetValue,
      onChange: (value) => {
        changeEquipmentWidgetValue(value)
        changeFormValue(`object`, get(head(value), `value`, null))
        onChange(get(head(value), `key`, null))
      },
    },
  })),
  omitProps(equipmentWidgetAdapterOmittedProps),
)

export default equipmentWidgetAdapter
